const ProposalStepCustomizationKeys = {
    titles: {
        compensation: 'compensation_step_title',
        products: 'select_products_step_title',
        tasks: 'tasks_step_title',
        'personal-info': 'other_info_step_title',
        'brand-assets': 'assets_step_title',
        'content-rights': 'content_rights_step_title'
    },
    campaign: {
        'submit-proposal-by': 'campaign_proposal_dates_header',
        'deliver-content-by': 'campaign_content_dates_header',
        'get-started': 'get_started_button_text'
    }
};
export default ProposalStepCustomizationKeys;
